import { useCallback, useEffect, useState } from 'react';
import {
  promptInstall as requestInstallPrompt,
  subscribeInstallPrompt,
} from '../pwa/installPrompt';

export function useInstallPrompt() {
  const [canPromptInstall, setCanPromptInstall] = useState(false);

  useEffect(() => {
    const unsubscribe = subscribeInstallPrompt((value) => setCanPromptInstall(Boolean(value)));
    return () => unsubscribe?.();
  }, []);

  const promptInstall = useCallback(async () => {
    const outcome = await requestInstallPrompt();
    return outcome;
  }, []);

  return { canPromptInstall, promptInstall };
}
